import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { MCC_PHOTOS } from "../data/images";
import { EASE } from "../utils/motion";
type LoaderProps = {
  instant?: boolean;
};
export function Loader({
  instant = false
}: LoaderProps) {
  const reduce = useReducedMotion();
  return <motion.div role="status" aria-live="polite" aria-label="Loading Maple Canadian College" initial={{
    opacity: instant ? 1 : 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: reduce ? 0.01 : 0.35,
    ease: EASE
  }} className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#061f38] text-white" data-id="element-289" data-mp="2vlkkj45ebz2n">
      <motion.img src={MCC_PHOTOS.crest} alt="" width={112} height={112} initial={{
      opacity: 0,
      scale: reduce ? 1 : 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: reduce ? 0.01 : 0.3,
      ease: EASE
    }} className="h-32 w-32 rounded-full bg-white object-contain p-3 shadow-[0_18px_40px_rgba(6,31,56,0.25)]" data-id="element-290" data-mp="3ekeywc0y6xia" />
      <motion.div initial={{
      opacity: 0,
      y: reduce ? 0 : 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: reduce ? 0.01 : 0.6,
      delay: reduce ? 0 : 0.25,
      ease: EASE
    }} className="mt-6 text-center" data-id="element-291" data-mp="26kck9hs04sbu">
        <p className="text-[11px] font-semibold tracking-[0.32em] text-white/85" data-id="element-292" data-mp="2fj7r8w2ve6g7">MAPLE CANADIAN COLLEGE</p>
        <p className="mt-2 text-[10px] tracking-[0.28em] text-white/45" data-id="element-293" data-mp="2u7u48r50ym49">START HERE · GO ANYWHERE</p>
      </motion.div>
      <div className="mt-8 h-px w-28 overflow-hidden bg-white/15" data-id="element-294" data-mp="2pcwvzmfkkgsf">
        <motion.div initial={{
        x: "-100%"
      }} animate={{
        x: "100%"
      }} transition={{
        duration: reduce ? 0.01 : 1.1,
        repeat: reduce ? 0 : Infinity,
        ease: [0.65, 0, 0.35, 1]
      }} className="h-full w-full bg-[#c5233d]" data-id="element-295" data-mp="339tkvic4no6o" />
      </div>
    </motion.div>;
}